import style from "../css/Thanku.module.css";
import { Check } from "lucide-react";
import UAParser from "ua-parser-js";
import confettiFlare from "../../../icons/flare2.png";
import boatBanner from "../../../icons/quiz banners/image 128.webp";
import goaBanner from "../../../icons/goaTripRules.png";
import Header from "../../Questions/component/Header";
import { Link, useNavigate } from "react-router-dom";
import { offerEvent } from "../../../utils/api";
import { useEffect, useState } from "react";
import banner1 from "../../../icons/fire.webp";
import FanduPointsToast from "./FanduPointsToast";

export default function OrderConfirmed() {
  let mId = localStorage.getItem("mId") || "2026";
  let uuid = localStorage.getItem("uuid");
  let session_id = localStorage.getItem("session_id");
  const [showToast, setShowToast] = useState(true);

  useEffect(() => {
    const timer = setTimeout(() => {
      setShowToast(false);
    }, 5000);

    return () => clearTimeout(timer);
  }, []);

  const navigate = useNavigate();

  const offerRequestData = (eventMetaData) => {
    const parser = new UAParser();
    const result = parser.getResult();

    return {
      machine_id: mId,
      device_id: uuid,
      session_id,
      ip_address: localStorage.getItem("ip_address"),
      lat: "",
      lng: "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
      firstname: "",
      lastname: "",
      email: "",
      phone: "",
      deviceBrand: result.device.vendor || "Unknown",
      deviceModel: result.device.model || "Unknown",
      deviceType: result.device.type || "desktop",
      osName: result.os.name || "Unknown",
      osVersion: result.os.version || "Unknown",
      browserName: result.browser.name || "Unknown",
      browserVersion: result.browser.version || "Unknown",
      event_ts: Date.now().toString(),
      user_id: localStorage.getItem("userId") || "",
      ...eventMetaData,
    };
  };

  const avail = (EventName, EventSubName, EventType, EventSubType) => {
    try {
      const requestData = offerRequestData({
        Event_Name: EventName,
        Event_Sub_Name: EventSubName,
        Event_Type: EventType,
        Event_Sub_Type: EventSubType,
      });

      offerEvent(requestData);
    } catch {}
  };

  useEffect(() => {
    avail(
      "Order_Confirmation_Page",
      "Order_Confirmation",
      "Page_Open",
      "Order",
    );

    localStorage.removeItem("userName");
    localStorage.removeItem("mathGameRewardCount");
    localStorage.removeItem("numberRainRewardCount");

    const handleBack = () => {
      navigate("/hot-deals", { replace: true });
    };

    window.history.pushState(null, "", window.location.href);

    window.addEventListener("popstate", handleBack);

    return () => {
      window.removeEventListener("popstate", handleBack);
    };
  }, [navigate]);

  return (
    <div>
      <Header />
      <FanduPointsToast
        points={100}
        visible={showToast}
        onClose={() => setShowToast(false)}
      />
      <div className={style.flareContainer}>
        <img src={confettiFlare} alt="flare" className={style.flare} />
      </div>

      <div className={style.page}>
        <div className={style.wrapper}>
          <div className={style.successCard}>
            <div className={style.checkWrap}>
              <Check size={38} strokeWidth={4} />
            </div>

            <h1 className={style.successTitle}>Order Confirmed</h1>
          </div>

          <Link
            to="/quiz-categories"
            onClick={() =>
              avail(
                "Order_Confirmation_Quiz_Landing",
                "Order_Confirmation_Quiz",
                "Click",
                "Quiz",
              )
            }
          >
            <img
              src={boatBanner}
              alt="Quiz Banner"
              className={style.bannerImg3}
            />
          </Link>

          <Link
            to="/questions"
            onClick={() =>
              avail(
                "Order_Confirmation_Quiz_Landing",
                "Order_Confirmation_Quiz",
                "Click",
                "Quiz_Categories",
              )
            }
          >
            <img
              src={goaBanner}
              alt="Goa Banner"
              className={style.bannerImg3}
            />
          </Link>

          <Link
            to="/fandu-offers"
            className={style.viewBtn}
            style={{
              textDecoration: "none",
              display: "flex",
              justifyContent: "center",
            }}
            onClick={() =>
              avail(
                "Order_Confirmation_Offer_Landing",
                "Order_Confirmation_Offer",
                "Click",
                "Offers",
              )
            }
          >
            Fandu Offers
          </Link>
        </div>

        <div className={style.hotDealsBottomRight}>
          <Link to="/hot-deals">
            <img src={banner1} alt="Hot Deals" className={style.hotDealsBtn} />
          </Link>
        </div>
      </div>
    </div>
  );
}
